/**
 * CompleteCTA — "시청 완료" 버튼.
 * VideoPlayer가 계산한 완료 조건 미달 시 disabled 상태로만 표현한다.
 * 완료 조건 충족 여부는 버튼의 활성/비활성 상태로 표현한다.
 */
import { useTranslation } from 'react-i18next'
import { Button3D } from '../ui/Button3D'
import { Button } from '../ui/Button'

interface Props {
  canComplete: boolean
  completing: boolean
  onComplete: () => void
  variant?: 'legacy' | 'v3'
}

export default function CompleteCTA({
  canComplete,
  completing,
  onComplete,
  variant = 'legacy',
}: Props) {
  const { t } = useTranslation('learner')

  if (variant === 'v3') {
    const disabled = !canComplete || completing
    return (
      <div className="flex w-full max-w-[160px] flex-col items-center pt-3">
        <Button
          variant="primary"
          size="XL"
          className="w-full"
          disabled={disabled}
          style={disabled ? { color: 'var(--color-lc-text-inverse)' } : undefined}
          onClick={onComplete}
        >
          {completing ? t('video.completeProcessing') : t('video.complete')}
        </Button>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center gap-2 pt-1">
      <Button3D
        variant="orange"
        size="L"
        disabled={!canComplete || completing}
        onClick={onComplete}
      >
        {completing ? t('video.completeProcessing') : t('video.complete')}
      </Button3D>
    </div>
  )
}
